module.exports = __webpack_public_path__ + "static/img/logo_germany.04d3f9b.png";